import * as permissionConstants from './permissions';

export class RoutePermission {
    path: string;
    permissions: string[];
}

export const ROUTE_PERMISSIONS: RoutePermission[] = [
    {
        path: 'sources',
        permissions: [permissionConstants.sourcesView]
    },
    {
        path: 'sources/:sourceId/editentities',
        permissions: [permissionConstants.sourcesEdit]
    },
    {
        path: 'schedules',
        permissions: [permissionConstants.schedulesView]
    },
    {
        path: 'monitoring',
        permissions: [permissionConstants.monitoringView]
    },
    {
        path: 'cobranding',
        permissions: [permissionConstants.cobrandingView]
    },
    {
        path: 'ui-permissions',
        permissions: [permissionConstants.accessManagementView]
    },
    {
        path: 'idea-permissions',
        permissions: [permissionConstants.dataEntryView]
    },
    {
        path: 'groups',
        permissions: [permissionConstants.accessGroupsView]
    },
    {
        path: 'users',
        permissions: [permissionConstants.accessUsersView]
    },
    {
        path: 'data-entry',
        permissions: [permissionConstants.dataEntryView]
    },
    {
        path: 'contacts',
        permissions: [permissionConstants.appCatalogView]
    },
    {
        path: 'catalog',
        permissions: [permissionConstants.appCatalogView]
    },
    {
        path: 'reports',
        permissions: [permissionConstants.reportingView]
    },
    {
        // promotionsTestCreate/promotionsProdCreate gate individual actions within the page
        // (e.g. Promotions Engineer role has view + test create but not prod create), so only
        // the base view permission gates route access.
        path: 'promotions',
        permissions: [permissionConstants.promotionsView]
    }
];
